// -----------------------------------------------------------------------------
// Scripts for history navigation
// -----------------------------------------------------------------------------

$(document).ready(function () {
  if($('.history').length) {
    const historyNav = $('.history-nav');
    let section = $('.history-section');

    function changeNavPosition() {
      let $window = $(window);
      let windowTopPosition = $window.scrollTop();
      const historyNavTopPos = historyNav.offset().top;

      if(windowTopPosition >= historyNavTopPos) {
        historyNav.addClass('history-nav--sticky');
      } else {
        historyNav.removeClass('history-nav--sticky');
      }
    }
  
    function checkSectionVisibility() {
      let $window = $(window);
      let windowHeight = $window.height();
      let windowTopPosition = $window.scrollTop();
      let windowBottomPosition = (windowTopPosition + windowHeight);
  
      $.each(section, function () {
        const $element = $(this);
        const elementId = $element.attr('id');
        const elementTitle = $element.attr('data-title');
        const elementYear = $element.attr('data-year');
        const elementHeight = $element.outerHeight();
        let elementTopPosition = $element.offset().top;
        let elementBottomPosition = (elementTopPosition + elementHeight);
        let navItem = $(`#${elementId}Nav`);
        let menuItem = $(`#${elementId}Menu`);
  
        if ((elementBottomPosition >= windowTopPosition) && (elementTopPosition <= windowBottomPosition) && !navItem.hasClass('history-nav__item-link--active')) {
          $('.history-nav__item-link').removeClass('history-nav__item-link--active');
          $('.history-menu__item-link').removeClass('history-menu__item-link--active');
          navItem.addClass('history-nav__item-link--active');
          menuItem.addClass('history-menu__item-link--active');
          $('.history-menu__header-title').text(elementTitle);
          $('.history-menu__header-years').text(elementYear);
        }
      });
    }

    $(window).on('scroll', function () {
      checkSectionVisibility();
      changeNavPosition();
    });
    $(window).trigger('scroll');
  
    $('.history-nav__item-link').on('click', function(event) {
      const item = $(this);
      const itemLink = item.attr('href');
  
      if (itemLink.length) {
        event.preventDefault();
        
        $('html, body').stop().animate({
          scrollTop: $(itemLink).offset().top - 100
        }, 'slow', 'linear');
      }
    });

    $('.history-menu__list-inner').scrollbar();
  
    $('.history-menu').on('click', function(event) {
      const target = $(event.target)
      const menu = $('.history-menu');
      const menuHeaderContent = menu.find('.history-menu__list');

      if(target.hasClass('history-menu__header')) {
        menu.toggleClass('history-menu--open');
        menuHeaderContent.slideToggle(300, 'linear');
      }

      if(target.hasClass('history-menu__item-link')) {
        const itemLink = target.attr('href');

        menuHeaderContent.slideUp(300, 'linear');
    
        if (itemLink.length) {
          event.preventDefault();
          
          $('html, body').stop().animate({
            scrollTop: $(itemLink).offset().top - 50
          }, 'slow', 'linear');
        }
      }
    });
  }
});